/* istanbul ignore file */

import type { MobileRoute } from '@lumapps/mobile-webview/message-emit/redirect/types';
import { Route } from '@lumapps/router';
import { AppId, URL_PREFIX } from '@lumapps/router/constants';

/**
 * Article view page path.
 *
 * Same as content view page path but with `type` replaced with `article`.
 */
export const articleViewPath = `/${URL_PREFIX}/article/id/:id`;

export const articleViewRoute: Route = {
    path: articleViewPath,
    appId: AppId.frontOffice,
};

export const articleView = (articleId: string, anchor?: string, instanceSlug?: string): MobileRoute => ({
    ...articleViewRoute,
    params: { id: articleId },
    instanceSlug,
    anchor,
    mobilePageDescriptor: { id: articleId, type: 'article' },
});
